import React from 'react';
import useABC from '../../Provider/TableContext/ABCContext';
import useSkill from '../../Provider/TableContext/SkillContext';
import useResponsibility from '../../Provider/TableContext/ResponsibilityContext';
import useQualification from '../../Provider/TableContext/QualificationContext';
import useRole from '../../Provider/TableContext/RoleContext';
import useProfile from '../../Provider/TableContext/ProfileContext';
import { generateIdealRoleHTML } from '../../Functions/Generator/IdealRoleGenerator';
import RoleStatus from '../../Constants/RoleStatus.json';
import {  trackException } from '../withApplicationInsight';

export default function useMyIdealRoleCompute() {
    const { profileData, updateProfile, loading: profileLoading } = useProfile();
    const { roles, updateRole, loading: roleLoading } = useRole();
    const { abcs, loading: abcLoading } = useABC();
    const { responsibilities, loading: respLoading } = useResponsibility();
    const { qualifications, loading: qualLoading } = useQualification();
    const { skills, loading: skillsLoading } = useSkill();
    
    const loading = React.useMemo(() =>
        abcLoading || respLoading || skillsLoading || qualLoading,
    [abcLoading, respLoading, skillsLoading, qualLoading]);
    const role = React.useMemo(() => Array.isArray(roles)? roles.find((role) => role.mcb_rolestatus === RoleStatus.Ideal) : undefined, [roles])

    const value = React.useMemo(() => {
        if (loading || !role) {
            return;
        }
        try {
            return generateIdealRoleHTML(role, responsibilities, qualifications, abcs, skills);
        } catch (error) {
            console.error("Error in computing Ideal Role: ", error);
            trackException({error, properties: {
                context: { role, abcs, responsibilities, qualifications, skills },
                relatedTo: "MyIdealRole Computation",
            }});
            return "Error while generating MyIdealRole. Please try again later.";
        }
    }, [role, abcs, responsibilities, qualifications, skills, loading]);
    
    React.useEffect(() => {
        if (loading || !value) return;
        if (!profileLoading && profileData._mcb_idealrole_value !== role.mcb_roleid) {
            updateProfile({ ...profileData, _mcb_idealrole_value: role.mcb_roleid }, false);
        }

        if (!roleLoading && role.mcb_rac !== value) {
            updateRole({ ...role, mcb_rac: value }, false);
        }
    }, [loading, profileLoading, roleLoading, value, profileData, updateProfile, role, updateRole]);

}